import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminPost, valiadteEmail, valiadteNumber } from "../../redux/Authentication/AuthSlice";
import { createEmployee, emailExists, mobileExists } from "../../redux/Employee/employeeSlice";
// import {
//   adminPost,
//   valiadteEmail,
//   valiadteNumber,
// } from "../../../redux/Authentication/AuthSlice";

const AddEmployee = () => {
    const dispatch = useDispatch();

    const [email, setEmail] = useState("");
    const [Cnfemail, setCnfEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [emailExistError, setEmailExistError] = useState("");
    const [mobile, setMobile] = useState("");
    const [mobileCnf, setMobileCnf] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [mobileExistError, setMobileExistError] = useState("");
    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");
    const [organistaionName, setOrganistaionName] = useState("");
    const [organistaionNameError, setOrganistaionNameError] = useState("");
    const [Password, setPassword] = useState("");
    const [PasswordError, setPasswordError] = useState("");

    const [role, setRole] = useState("")
    const [roleError, setRoleError] = useState("")

    const [btnPress, setbtnPress] = useState(false);

    useEffect(() => {
        if (btnPress === true) {
            if (name === "") {
                setNameError("please enter title");
            } else {
                setNameError("");
            }
            if (Password === "") {
                setPasswordError("please enter Password");
            } else {
                setPasswordError("");
            }
            if (Cnfemail === "") {
                setEmailError("please enter email");
            } else {
                setEmailError("");
            }
            if (mobileCnf.length !== 10) {
                setMobileError("please enter mobile");
            } else {
                setMobileError("");
            }
            if (role === "") {
                setRoleError("Please select one of the role")
            } else {
                setRoleError("")
            }
            if (organistaionName === '') {
                setOrganistaionNameError('please enter organisation name')
            } else {
                setOrganistaionNameError('')
            }
        }
    }, [btnPress, name, Password, Cnfemail, mobileCnf, role, organistaionName]);

    const setNumberChange = async (e) => {
        const value = e.target.value.replace(/\D/g, "");
        setMobileError("");
        setMobileExistError('')
        setMobileCnf(value)
        if (value.length === 10) {
            const verifyNumber = await dispatch(mobileExists(value));
            if (verifyNumber.payload.success) {
                setMobileError("Number already exist");
                setMobileExistError("Mobile number already exists");
            } else {
                setMobileExistError("");
                setMobileError("");
                setMobileCnf(value);
            }
        } else {
            setMobileError("");
        }
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const emailChange = async (email) => {
        setEmail(email);
        setEmailError('');
        setEmailExistError('');

        if (!validateEmail(email)) {
            setEmailError('Please enter a valid email address.');
            return;
        }

        const verifyEmail = await dispatch(emailExists(email));

        if (verifyEmail.payload.success) {
            setEmailExistError('Email already exists.');
            setEmailError('Email already exists.')
        } else {
            setCnfEmail(email);
        }
    };


    const validatePassword = (password) => {
        const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])(?=.{8,})/;
        if (!passwordRegex.test(password)) {
            setPasswordError('Password must be at least 8 characters long and contain at least one number and one special character.');
        } else {
            setPasswordError('');
        }
    };

    const handleKeyUp = (e) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        // Validate password on each keyup event
        // validatePassword(newPassword);
    };

    const handleBlur = () => {
        // Validate password on blur event
        validatePassword(Password);
    };


    const cancelClick = async (e) => {
        e.preventDefault();
        setEmail("");
        setCnfEmail("");
        setMobile("");
        setMobileCnf("");
        setName("");
        setPassword("");
        setRole("")
        setOrganistaionName('')
    };

    const handlesubmit = async (e) => {
        e.preventDefault();
        if (name === "") {
            setNameError("please enter title");
        } else {
            setNameError("");
        }
        if (Password === "") {
            setPasswordError("please enter Password");
        } else {
            setPasswordError("");
        }
        if (Cnfemail === "") {
            setEmailError("please enter email");
        } else {
            setEmailError("");
        }
        if (mobileCnf.length !== 10) {
            setMobileError("please enter mobile");
        } else {
            setMobileError("");
        }
        if (role === "") {
            setRoleError("Please select role")
        } else {
            setRoleError("")
        }
        if (organistaionName === '') {
            setOrganistaionNameError('please enter organisation name')
        } else {
            setOrganistaionNameError('')
        }
        if (name !== "" && Password !== "" && Cnfemail !== "" && mobileCnf !== "" && role !== "" && organistaionName!=='') {
            const formData = {
                name: name,
                password: Password,
                role: role,
                email: Cnfemail,
                phone: mobileCnf,
                organisation:organistaionName
            };
            const admin = await dispatch(createEmployee(formData));
            if (admin.payload.success) {
                alert(`${role} created successfully`);
                setEmail("");
                setCnfEmail("");
                setMobile("");
                setMobileCnf("");
                setName("");
                setPassword("");
                setRole("")
                setOrganistaionName('')
                setbtnPress(false)
            }
        } else {
            setbtnPress(true);
        }
    };

    return (
        <>
            <div className="min-h-screen flex flex-col lg:ps-64 w-full">
                <div className="p-6 space-y-6">
                    <div className="flex items-center justify-between w-full print:hidden">
                        <h4 className="text-lg font-semibold text-default-900">
                            Add Client Details
                        </h4>

                    </div>
                    <div className="shadow rounded-lg bg-white dark:bg-default-50 h-fit">
                        <div className="flex items-center justify-between py-4 px-5">
                            <h4 className="text-lg font-medium text-default-950 capitalize">
                                Add Client Details
                            </h4>
                        </div>
                        <div className="p-5 border-t border-dashed border-default-200">
                            <div className="grid md:grid-cols-2 gap-4">
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Name *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            nameError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fName"
                                        placeholder="Enter Name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="lName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Phone *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            mobileError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="lName"
                                        placeholder="Enter Phone"
                                        minLength={10}
                                        maxLength={10}
                                        value={mobileCnf}
                                        onChange={(e) => setNumberChange(e)}
                                    />
                                    <div>{mobileExistError}</div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="lName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Email *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            emailError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="rollNo"
                                        placeholder="Enter Email"
                                        value={email}
                                        onChange={(e) => emailChange(e.target.value)}
                                    />
                                    <div>{emailExistError}</div>
                                </div>

                                <div className="space-y-1">
                                    <label
                                        htmlFor="datepicker-basic"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Password *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            PasswordError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        placeholder="Enter Password"
                                        id="datepicker-basic"
                                        value={Password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        onKeyUp={handleKeyUp}
                                        onBlur={handleBlur}
                                    />
                                    <div>
                                        {PasswordError && (
                                            <div className="text-red-500 text-xs mt-1">{PasswordError}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="datepicker-basic"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Add Organisation Name
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            organistaionNameError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        placeholder="Enter Organisation Name"
                                        id="datepicker-basic"
                                        value={organistaionName}
                                        onChange={(e) => setOrganistaionName(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center justify-between py-4 px-5">
                            <h4 className="text-lg font-medium text-default-950 capitalize">
                                Role Assign
                            </h4>
                        </div>
                        <div className="px-5">{roleError !== "" ? (<><p style={{ color: 'red' }}>Please select one of the role</p></>) : (<></>)}</div>
                        <div className="p-5 border-t border-dashed border-default-200">
                            <div className="grid md:grid-cols-2 gap-4">
                                <div className="space-y-1">
                                    <div className="radio-wrapper-6">
                                        <input
                                            className="tgl tgl-light"
                                            id="manager"
                                            type="radio"
                                            name="role"
                                            value="client"
                                            checked={role === "client"}
                                            onChange={(e) => {
                                                setRole(e.target.value);
                                            }}
                                        />
                                        <label
                                            className="text-sm font-medium text-default-900 ps-2"
                                            htmlFor="manager">Client
                                        </label>
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <div className="radio-wrapper-6">
                                        <input
                                            className="tgl tgl-light"
                                            id="agent"
                                            type="radio"
                                            name="role"
                                            value="customer"
                                            checked={role === "customer"}
                                            onChange={(e) => {
                                                setRole(e.target.value);
                                            }}
                                        />
                                        <label
                                            className="text-sm font-medium text-default-900 ps-2"
                                            htmlFor="agent">
                                            Customer
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="flex items-center gap-2 justify-end" style={{ marginBottom: '60px' }}>
                        <button
                            onClick={(e) => cancelClick(e)}
                            style={{ background: "#ef4444", color: 'text' }}
                            className="py-2 px-5 inline-flex items-center justify-center gap-2 font-semibold tracking-wide border align-middle duration-500 text-sm text-center bg-default-800 hover:bg-default-950  text-default-50 rounded"
                        >
                            <i className="ph-bold ph-x text-lg" /> Reset
                        </button>
                        <button
                            className="py-2 px-5 inline-flex items-center justify-center gap-2 font-semibold tracking-wide border align-middle duration-500 text-sm text-center bg-default-800 hover:bg-default-950  text-default-50 rounded"
                            style={{ background: "#8481ff" }}
                            onClick={(e) => handlesubmit(e)}
                        >
                            <i className="ph-duotone ph-cloud-arrow-up text-lg" />
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddEmployee;
